import React from "react";
import CTAButton from "../CTAButton/CTAButton";
import TestimonialSlider from "../TestimonialSlider/TestimonialSlider";
import "./Features.css";
import build from "../../assets/feature-image.png";
import grow from "../../assets/connect.png";
import automate from "../../assets/automate.png";
import tailor from "../../assets/tailor.png";
import analyse from "../../assets/analyse.png";
import gdpr from "../../assets/GDPR.png";
import api from "../../assets/API.png";
import { Link } from 'react-router-dom';
import report from "../../assets/Report.png";
import ManagedFaqSection, { pageFaqDefaults } from "../ManagedFaqSection/ManagedFaqSection";

const Features = () => {
  return (
    <div className="features-page">
      <section className="features-hero">
        <h1>Email Marketing Features That Help Your Business Grow</h1>
        <p>
          Discover powerful email marketing features designed to help you attract subscribers, create professional email campaigns, automate customer communication, and measure campaign performance from one intuitive platform. MailSnappy combines AI powered email marketing, <Link className="linkcolor" to="/templates">responsive email templates</Link>, audience management, automation, and analytics to help businesses of every size build stronger customer relationships and achieve sustainable business growth.
        </p>
        <div className="hero-form"><CTAButton>Get started</CTAButton></div>
      </section>

      <section className="feature-block">
        <div className="feature-text">
          <h2>Grow Your Email List with Signup Forms and Landing Pages</h2>
          <p>
            Build your audience using customizable signup forms and responsive landing pages designed to capture more leads and grow your email list. Create mobile friendly forms, collect valuable subscriber information, and turn website visitors into loyal subscribers with tools that make lead generation simple and effective.
          </p>
          <CTAButton className="primary-btn" to="/grow-audience">Explore audience growth tools</CTAButton>
        </div>
        <div className="feature-image">
          <img src={grow} alt="Email audience growth tools preview" width="640" height="420" loading="lazy" />
        </div>
      </section>

      <section className="feature-block reverse">
        <div className="feature-image">
          <img src={build} alt="Responsive email builder preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="feature-text">
          <h2>Build Professional Email Campaigns Without Coding</h2>
          <p>
            Design beautiful email campaigns using an intuitive drag and drop email builder that requires no coding experience. Choose from professionally designed responsive email templates, customize every element to match your brand, and create engaging newsletters, promotional emails, and customer updates that perform across all major email clients.
          </p>
          <p>
            For a deeper look at reusable layouts, visit the <Link className="linkcolor" to="/email-template-builder">email template builder</Link>.
          </p>
          <CTAButton className="primary-btn" kind="builder">Explore the email builder</CTAButton>
        </div>
      </section>

      <section className="feature-block">
        <div className="feature-text">
          <h2>Email Marketing Automation That Works While You Grow</h2>
          <p>
            Email marketing automation helps you stay connected with your audience without manually sending every email. MailSnappy lets you create automated email workflows for welcome emails, follow up campaigns, abandoned cart reminders, lead nurturing, and customer engagement. Trigger personalized email campaigns based on subscriber actions and deliver the right message at every stage of the customer journey.
          </p>
          <p>
            You can also review the focused <Link className="linkcolor" to="/email-automation-software">email automation software</Link> page for automation-specific workflows.
          </p>
          <CTAButton className="primary-btn" to="/automation">Explore email automation</CTAButton>
        </div>
        <div className="feature-image">
          <img src={automate} alt="Email marketing automation example" width="640" height="420" loading="lazy" />
        </div>
      </section>

      <TestimonialSlider title="Email marketing teams grow faster with Mailsnappy" />

      <section className="feature-block reverse">
        <div className="feature-image">
          <img src={tailor} alt="Personalized email campaign preview" width="640" height="420" loading="lazy" />
        </div>
        <div className="feature-text">
          <h2>Personalized Email Marketing for Higher Open Rates and Conversions</h2>
          <p>
            Increase engagement with personalized email marketing powered by subscriber data, custom fields, tags, and audience segmentation. MailSnappy helps you deliver relevant email campaigns based on customer interests and behavior, improving open rates, click through rates, customer relationships, and overall email marketing performance.
          </p>
          <CTAButton className="primary-btn" to="/segmentation">Explore email segmentation</CTAButton>
        </div>
      </section>

      <section className="feature-block">
        <div className="feature-text">
          <h2>Email Campaign Analytics That Improve Every Marketing Decision</h2>
          <p>
            Measure the success of every email campaign with detailed email analytics and real time reporting. Track open rates, click through rates, subscriber engagement, campaign performance, and conversions from a single dashboard. MailSnappy gives you the insights you need to optimize future email marketing campaigns and achieve better business results.
          </p>
          <CTAButton className="primary-btn" to="/analytics">Explore campaign analytics</CTAButton>
        </div>
        <div className="feature-image">
          <img src={analyse} alt="Email campaign analytics dashboard" width="640" height="420" loading="lazy" />
        </div>
      </section>

      <section className="extra-section">
        <h2>Advanced Email Marketing Features Built for Growth</h2>
        <p>
          Take your email marketing to the next level with advanced features designed to help your business grow faster and smarter. MailSnappy combines GDPR compliance, powerful email marketing reporting, campaign analytics, and an upcoming Developer API in one reliable email marketing platform. Protect subscriber data, track campaign performance with detailed insights, and seamlessly integrate your applications to automate workflows and improve customer engagement. Whether you are scaling a startup, ecommerce store, SaaS business, or enterprise, MailSnappy gives you the advanced email marketing features you need to create better campaigns, increase conversions, and drive long term business growth.
        </p>
        <div className="extra-grid">
          <div className="extra-item">
            <img src={gdpr} alt="GDPR compliance feature icon" width="96" height="96" loading="lazy" />
            <p>GDPR compliance</p>
          </div>
          <div className="extra-item">
            <img src={report} alt="Email reporting feature icon" width="96" height="96" loading="lazy" />
            <p>Powerful reporting</p>
          </div>
          <div className="extra-item">
            <img src={api} alt="Developer API feature icon" width="96" height="96" loading="lazy" />
            <p>Coming soon Developer API</p>
          </div>
        </div>
      </section>

      <ManagedFaqSection
        pageKey="features"
        heading="Email marketing feature FAQs"
        fallback={pageFaqDefaults.features}
      />

      <section className="cta-section">
        <h2>Start for free today</h2>
        <p>Sign up and send your first campaign in minutes. No credit card required.</p>
        <CTAButton className="primary-btn">Get started</CTAButton>
      </section>
    </div>
  );
};

export default Features;
